import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/auth/hooks/useAuth';

/**
 * Shared behavior for dev-console notification badges (plugin reviews,
 * provider issues): admin-only, polled every 60s so the badge clears shortly
 * after the condition resolves, with a staleTime so window-focus refetches
 * dedupe against the interval instead of hammering the endpoint on tab
 * switches.
 */
export function useAdminBadgeCount(
  queryKey: readonly unknown[],
  queryFn: () => Promise<{ count: number }>,
): number {
  const { user } = useAuth();
  const isAdmin = user?.roles?.includes('admin') ?? false;

  const { data } = useQuery({
    queryKey,
    queryFn,
    enabled: isAdmin,
    refetchInterval: 60_000,
    refetchOnWindowFocus: true,
    staleTime: 45_000,
  });

  return data?.count ?? 0;
}
